import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CutIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3143 30.9595C24.7118 30.9595 21.861 33.7315 21.861 37.0673C21.861 40.403 24.7118 43.175 28.3143 43.175C31.9169 43.175 34.7676 40.403 34.7676 37.0673C34.7676 33.7315 31.9169 30.9595 28.3143 30.9595ZM20.0277 37.0673C20.0277 32.6486 23.7762 29.1345 28.3143 29.1345C32.8524 29.1345 36.6009 32.6486 36.6009 37.0673C36.6009 41.4859 32.8524 45 28.3143 45C23.7762 45 20.0277 41.4859 20.0277 37.0673Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2004 3.04088C31.6841 3.18961 31.9551 3.70052 31.8057 4.18204L22.138 35.3412C21.9886 35.8227 21.4753 36.0925 20.9916 35.9438C20.5079 35.795 20.2369 35.2841 20.3863 34.8026L30.054 3.64346C30.2034 3.16194 30.7166 2.89216 31.2004 3.04088Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2866 13.78C6.68407 13.78 3.83332 16.552 3.83332 19.8877C3.83332 23.2235 6.68407 25.9955 10.2866 25.9955C13.8892 25.9955 16.7399 23.2235 16.7399 19.8877C16.7399 16.552 13.8892 13.78 10.2866 13.78ZM2 19.8877C2 15.4691 5.74854 11.955 10.2866 11.955C14.8247 11.955 18.5732 15.4691 18.5732 19.8877C18.5732 24.3064 14.8247 27.8205 10.2866 27.8205C5.74854 27.8205 2 24.3064 2 19.8877Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9652 17.1574C46.1029 17.6424 45.8197 18.1467 45.3325 18.2838L12.6138 27.4941C12.1267 27.6312 11.6201 27.3492 11.4823 26.8643C11.3446 26.3793 11.6278 25.875 12.115 25.7379L44.8337 16.5276C45.3208 16.3905 45.8274 16.6725 45.9652 17.1574Z"
  }));
});
CutIcon.displayName = 'CutIcon';
CutIcon.defaultProps = {
  'aria-label': 'Cut'
};
export default CutIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CutIcon/index.js
// module id = 1823
// module chunks = 12